import React from 'react';
import { setTabOnFocus, setFocusElement, setSelectedTransactionId, reRenderInfoBuilder, toggleRightDrawer } from '../../../store/global/actions';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { getElementOnFocus, getRightDrawerStatus } from '../../../store/global/selectors';



export default function Hyperlink({ children, id, type, screen, tab, transactionId, item, name, mode, protocol, desc }) {

    const dispatch = useDispatch();
    const history = useHistory();
    
    const elementOnFocus = useSelector(getElementOnFocus);
    const rightDrawerStatus = useSelector(getRightDrawerStatus);
    

    const onHyperLinkClick = () => {
        if(elementOnFocus && elementOnFocus?.transaction !== undefined){
            dispatch(setFocusElement({
                transaction: elementOnFocus?.transaction,
                id: id,
                type: type,
                name: name,
                item: item,
                mode: mode,
                protocol: protocol,
                desc: desc
            }))
        }else{
            if(type === "event" || type === "transaction"){
                if(rightDrawerStatus) dispatch(toggleRightDrawer()); 
                dispatch(setFocusElement({
                    transaction: transactionId,
                    id: id,
                    type: type,
                    name: name,
                    item: item,
                    mode: mode,
                    protocol: protocol,
                    desc: desc
                }))
            }else{
                dispatch(setFocusElement({
                    id: id,
                    type: type,
                    name: name,
                    item: item,
                    mode: mode,
                    protocol: protocol,
                    desc: desc
                }))
            }
    
        }

        if (tab){
            dispatch(setTabOnFocus(tab))
        } else{
            dispatch(setTabOnFocus(0))
        } 

        if (screen) {
            const [, , slug, id, currentTag, entittyId] = history.location.pathname.split("/");
            if (transactionId) {
                history.push(`/blueprint/${slug}/${id}/${screen}/${transactionId}`);
            } else {
                history.push(`/blueprint/${slug}/${id}/${screen}`);
            }
        }



        if (screen === 'transaction') {
            dispatch(setSelectedTransactionId(id))
            dispatch(reRenderInfoBuilder());
        }
    }

    return (
        <a href="javascript:void(0);" onClick={onHyperLinkClick}>{children}</a>
    )
}

